import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './UpdateStaff.module.css';

function UpdateStaff() {
    const { id, subject } = useParams();
    const [file, setFile] = useState();
    const [name, setName] = useState('');
    const [position, setPosition] = useState('');
    const [email, setEmail] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`https://school-web-server-eight.vercel.app/getStaff/${subject}/${id}`)
            .then(result => {
                const { name, position, email } = result.data;
                setName(name);
                setPosition(position);
                setEmail(email);
            })
            .catch(err => console.log(err));
    }, [id, subject]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('position', position);
            formData.append('email', email);
            if (file) {
                formData.append('file', file);
            }

            await axios.put(`https://school-web-server-eight.vercel.app/updateStaff/${subject}/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            navigate('/login/managestaff');
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className={styles.updateStaffContainer}>
            <div className={styles.updateContent}>
                <form onSubmit={handleUpdate}>
                    <h2>อัพเดทข้อมูล</h2>
                    <div className={styles.formInput}>
                        <label htmlFor="image">รูปภาพ</label>
                        <input type="file" className={styles.updateForm} onChange={e => setFile(e.target.files[0])} />
                    </div>
                    <div className={styles.formInput}>
                        <label htmlFor="name">ชื่อ-สกุล</label>
                        <input
                            type="text"
                            placeholder='กรอกชื่อ-สกุล'
                            className={styles.updateForm}
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                e.target.setCustomValidity('');
                            }} 
                            onInvalid={(e) => e.target.setCustomValidity('กรุณากรอกชื่อ-สกุล')}
                            required 
                        />
                    </div>
                    <div className={styles.formInput}>
                        <label htmlFor="position">ตำแหน่ง</label>
                        <input type="text" placeholder='กรอกตำแหน่ง' className={styles.updateForm} value={position} onChange={(e) => setPosition(e.target.value)} />
                    </div>
                    <div className={styles.formInput}>
                        <label htmlFor="email">อีเมล์</label>
                        <input type="email" placeholder='กรอกอีเมล์' className={styles.updateForm} value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <button className={styles.updateStaffBt}>อัพเดทข้อมูล</button>
                    <button type="button" className={styles.backBtn} onClick={() => navigate('/login/managestaff')}>กลับหน้าหลัก</button>
                </form>
            </div>
        </div>
    );
}

export default UpdateStaff;
